<template>
  <div>
    <div class="row">
      <div class="form-group col-lg-12">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          :options="clients"
          :getOptionLabel="item => `${item.CLI_ID} - ${item.CLI_DSC}`"
          :initial-value="query.client"
          v-model="query.client"
          :reduce="client => client.CLI_ID"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-8">
        <label for="event_id">{{ $t('event_id') }}</label>
        <input
          type="text"
          id="event_id"
          name="event_id"
          class="form-control"
          :placeholder="$t('ph_event_id')"
          v-model="query.id"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="isActive">{{ $t('active') }}</label>
        <Combobox
          class="bg-white"
          name='isActive'
          :placeholder="$t('select_a_item')"
          label='name'
          :options="[{ name: 'SIM', value: true }, { name: 'NÃO', value: false }]"
          :reduce="isActive => isActive.value"
          :initial-value="query.isActive"
          v-model="query.isActive"
        />
      </div>
    </div>

    <div class="row mb-5">
      <button
        class="btn btn-primary mx-3"
        @click="search"
        :disabled="!query.id && !query.client && !query.vehicle"
      >
        Buscar
      </button>

      <button
        class="btn btn-white"
        @click="clear"
      >
        {{ $t('clear') }}
      </button>
    </div>

    <div class="row">
      <div class="col-12">
        <b-table
          responsive='xl'
          bordered
          hover
          class="bg-white"
          :items="events"
          :fields='fields'
        >
          <template v-slot:cell(CLI_ID)={item}>
            {{ getClientName(item.CLI_ID) }}
          </template>

          <template v-slot:cell(VEI_ID)={item}>
            {{ item.VEI_ID + ' / ' + item.VEI_PLC }}
          </template>

          <template v-slot:cell(EVN_TV1)={item}>
            {{ item.EVN_TV1 + getEvent(item.EVN_TV1, item.EVN_VR1) }}
          </template>

          <template v-slot:cell(EVN_TV2)={item}>
            {{ item.EVN_TV2 + getEvent(item.EVN_TV2, item.EVN_VR2) }}
          </template>

          <template v-slot:cell(EVN_TV3)={item}>
            {{ item.EVN_TV3 + getEvent(item.EVN_TV3, item.EVN_VR3) }}
          </template>

          <template v-slot:cell(EVN_ACE)={item}>
            {{ item.EVN_ACE == 4 ? 'NÃO' : 'SIM' }}
          </template>

          <template v-slot:cell(action)={item}>
            <a
              :href="`#/main/arenaevents/edit/${item.id}`"
              title="Editar"
              class="edit mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
            >
              <i class="fas fa-pen" />
            </a>

            <button
              v-if="item.EVN_ACE != 4"
              type="button"
              title="Desativar"
              data-target="#modalConfirmInactiveEvent"
              data-toggle="modal"
              class="mb-1 btn btn-action btn-danger btn-circle light-bottom-shadow text-white ml-1"
              @click="() => showModalConfirmInactiveEvent(item)"
            >
              <i class="fas fa-ban fa-lg" />
            </button>
          </template>
        </b-table>
      </div>
    </div>

    <!-- MODAL CONFIRM INACTIVE EVENT -->
    <div class="modal fade" id="modalConfirmInactiveEvent" tabindex="-1" role="dialog" aria-labelledby="modalConfirmInactiveEventLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmInactiveEventLabel">Confirmar desativar evento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                ID Evento: <strong>{{ eventToInactivate.EVN_ID }}</strong>
              </li>
              <li>
                Descrição: <strong>{{ eventToInactivate.EVN_TPV }}</strong>
              </li>
              <li>
                Cliente: <strong>{{ getClientName(eventToInactivate.CLI_ID) }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t('close') }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="handleInactive"
              :loading="isLoading"
            >
              {{ $t('confirm') }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Combobox from '@/components/shared/ComboBox'
import events from '../../../../config/events'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'ArenaEventListComponent',
  components: {
    Combobox,
    LoaderButton
  },

  data () {
    return {
      query: {
        id: undefined,
        client: undefined,
        vehicle: undefined,
        isActive: undefined
      },
      fields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'EVN_TPV',
          label: this.$t('description')
        },
        {
          key: 'CLI_ID',
          label: this.$t('client')
        },
        {
          key: 'EVN_ACE',
          label: this.$t('active')
        },
        {
          key  : 'action',
          label: '',
          class: ['text-center']
        }
      ],
      eventsMapped: {},
      eventToInactivate: {}
    }
  },

  watch: {
    'query.client'(value) {
      if (!value) {
        return this.query.vehicle = undefined
      }

      this.loadVehicles(value)
    }
  },

  computed: {
    ...mapState({
      clients: state => state.arena.clients,
      vehicles: state => state.arena.vehiclesByClient,
      events: state => state.arena.events,
      isLoading: state => state.arena.isLoading
    })
  },

  methods: {
    ...mapActions('arena', [
      'fetchVehiclesByClient',
      'fetchEvents',
      'clearEvents',
      'inactivateArenaEvent'
    ]),

    clear() {
      this.query.id = undefined
      this.query.client = undefined
      this.query.vehicle = undefined
      this.query.isActive = undefined

      this.clearEvents()
    },

    async loadVehicles(client) {
      await this.fetchVehiclesByClient({ client })
    },

    async search() {
      await this.fetchEvents(this.query)
    },

    getClientName(id) {
      const values = [id]

      const found = this.clients.find(client => client.CLI_ID == id)

      found && values.push(found.CLI_DSC)

      return values.join(' - ')
    },

    getEvent(property, propertyVR) {
      if (property == 16 && String(propertyVR).includes('.')) {
        property = '16.1'
      }

      const eventName = this.eventsMapped[property] || ''

      return eventName ? ` - ${eventName}` : ''
    },

    showModalConfirmInactiveEvent(item) {
      this.eventToInactivate = item

      $('#modalConfirmInactiveEvent').modal('show')
    },

    async handleInactive() {
      const inactivated = await this.inactivateArenaEvent(this.eventToInactivate.EVN_ID)

      if (inactivated) {
        $('#modalConfirmInactiveEvent').modal('hide')

        this.search()
      }
    }
  },

  async mounted () {
    await this.$store.dispatch('arena/fetchClients')

    this.eventsMapped = events.reduce((accumulator, current) => {
      accumulator[current.id] = current.description

      return accumulator
    }, {})

    const global = this

    $('#modalConfirmInactiveEvent').on('hide.bs.modal', function (event) {
      global.eventToInactivate = {}
    })
  },
}
</script>
